import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { Editor } from 'tinymce';
import { broadcastEvents } from 'common/common/constants/broadcast-events';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import {
  copyAttachment,
  deleteAttachment
} from 'common/store/genesys-cloud/conversations/emails/actions/email-message.actions';
import { Attachment } from 'common/store/genesys-cloud/conversations/emails/models/attachment.model';
import { EmailMessage } from 'common/store/genesys-cloud/conversations/emails/models/email-message.model';
import { GenesysEmailComposeService } from '../services/genesys-email-compose.service';

@Component({
  selector: 'app-genesys-email-editor',
  templateUrl: './genesys-email-editor.component.html',
  styleUrls: ['./genesys-email-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysEmailEditorComponent {
  static readonly emptyString = String.fromCharCode(parseInt('00A0', 16));
  readonly editorInitSetting = {
    toolbar: 'bold italic underline strikethrough link bullist numlist outdent indent undo redo'
  };
  @Input() conversationId: string;
  @Input() lastEmail: EmailMessage;
  @Input() draftAttachments: Attachment[] = [];
  @Input() htmlBody = '';
  @Input() showQuoteButton = false;

  @Output() addQuotedContent = new EventEmitter();
  @Output() editorContentChange = new EventEmitter();

  editorInstance: Editor = null;

  constructor(
    private readonly _emailComposeService: GenesysEmailComposeService,
    private readonly store: Store,
    private readonly _rxEmitter: RxEmitter
  ) {}

  onAddQuotedContent(): void {
    const originalEmailMessage = this._emailComposeService.addOriginalEmailMessageForMessage(
      this.htmlBody,
      this.lastEmail
    );
    this.addQuotedContent.emit(originalEmailMessage);

    if (this.lastEmail.attachments?.length > 0) {
      this.store.dispatch(
        copyAttachment({
          conversationId: this.conversationId,
          sourceMessageId: this.lastEmail.id,
          attachments: this.lastEmail.attachments
        })
      );
    }
  }

  onEditorSetupDone(editor: Editor): void {
    if (editor.initialized) {
      this._rxEmitter.send(broadcastEvents.focusEditor, null);
    } else {
      editor.on('init', () => {
        this._rxEmitter.send(broadcastEvents.focusEditor, null);
      });
    }
    this.editorInstance = editor;
  }

  onEditorContentChange(content: string): void {
    const textBody = this.editorInstance.getContent({ format: 'text' }) || GenesysEmailEditorComponent.emptyString;
    this.editorContentChange.emit({ htmlBody: content, textBody });
  }

  deleteFile(attachment: Attachment): void {
    this.store.dispatch(deleteAttachment({ conversationId: this.conversationId, attachmentMeta: attachment }));
  }
}
